import { Caption } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { Info } from '@liveauctioneers/hammer-ui-core/icons';
import { Tooltip } from '@liveauctioneers/hammer-ui-core/tooltip';
import { useBidIncrementsInBidPanel } from '@/utils/amplitude/experiments/hooks/useBidIncrementsInBidPanel';
import { useState } from 'react';
import SelectBidDropdown from '@/components/Modals/AuthModal/AbsenteeBid/pages/AbsenteeBid/components/PlaceBidForm/components/SelectBidDropdown/SelectBidDropdown';

type Props = {
    itemId: number;
};

const MaxBidSelector = ({ itemId }: Props) => {
    const [isOpen, setIsOpen] = useState(false);
    const hasBidIncrementsInBidPanelTreatment = useBidIncrementsInBidPanel();
    const showPlaceholderOnInit = hasBidIncrementsInBidPanelTreatment;

    return (
        <>
            {!showPlaceholderOnInit && (
                <div className="flex flex-row">
                    <Caption color="secondary">
                        <FormattedMessage id="itemPage.experiment.variant.maxBid" />
                    </Caption>
                    <Info
                        className="z-[1100] ml-[4px] mt-[2px] cursor-pointer touch-manipulation"
                        color="primary"
                        data-testid="shipping-cost-popover"
                        id="max-bid-info-trigger"
                        onClick={() => setIsOpen(!isOpen)}
                        onMouseEnter={() => setIsOpen(true)}
                        onMouseLeave={() => setIsOpen(false)}
                        role="button"
                        size="xs"
                    />
                    <Tooltip
                        anchorSelect="#max-bid-info-trigger"
                        isOpen={isOpen}
                    >
                        <FormattedMessage id="itemPage.experiment.variant.maxBidInfo" />
                    </Tooltip>
                </div>
            )}
            <SelectBidDropdown
                className={cn('w-full', {
                    'mb-sm': hasBidIncrementsInBidPanelTreatment,
                    'mb-xs': !hasBidIncrementsInBidPanelTreatment,
                })}
                disabled={false}
                itemId={itemId}
                showPlaceholderOnInit={showPlaceholderOnInit}
            />
        </>
    );
};

export { MaxBidSelector };
